export enum CommunicationType {
  Email = 1,
  SMS = 2,
  Global = 3,
  RetentionCampaigns = 4,
}
